import srb from './srb';
import eng from './eng';
import deu from './deu';

const languages = { srb, eng, deu };

export default languages;